export default class HouseAdVariantSelectionStrategy {}
HouseAdVariantSelectionStrategy.First = 'first';
HouseAdVariantSelectionStrategy.Random = 'random';
HouseAdVariantSelectionStrategy.StatsigExperiment = 'statsig-experiment';
